import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { SelectModule } from 'src/app/common-components/entity-select/select/select.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { AccountRegisterComponent } from './containers/account-register.component';
import { AccountRegisterEffects } from './state/account-register.effects';
import { accountRegisterFeatureKey, accountRegisterReducer } from './state/account-register.reducer';
import { AccountRegisterViewComponent } from './views/account-register-view.component';

@NgModule({
   declarations: [AccountRegisterComponent, AccountRegisterViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      DatePipe,
      ReactiveFormsModule,
      RouterModule,
      ScrollingModule,
      RegisterModule,
      MatSlideToggleModule,
      SelectModule,
      EntitySelectModule,
      MatMenuModule,
      EffectsModule.forFeature([AccountRegisterEffects]),
      StoreModule.forFeature(accountRegisterFeatureKey, accountRegisterReducer),
   ],
})
export class AccountRegisterModule {}
